<template>
    <div class="content-wrapper">
        <app-breadcrumb :page-title="$t('tax_statement')"/>

        <app-table :id="tableId" :options="options"/>
    </div>
</template>

<script>
import {status} from "../../../Mixins/FilterMixin";
import TaxStatementReportMixin from "../../../Mixins/TaxStatementReportMixin";

export default {
    name: 'TaxStatementReport',
    mixins: [TaxStatementReportMixin, status]
}
</script>
